import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '@/store'
import {
  DefaultLayout
} from "@/layouts";

export const Route = createFileRoute('/_protected' as any)({
  beforeLoad: ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/',
        search: {
          redirect: location.pathname + location.search,
        },
      })
    }
  },
  component: DefaultLayout,
})
